"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoverageEntry = void 0;
let CoverageEntry = exports.CoverageEntry = void 0;
(function (_CoverageEntry) {
  let Type = /*#__PURE__*/function (Type) {
    Type["ONLINE"] = "online";
    Type["SOCIAL"] = "social";
    Type["PRINT"] = "print";
    Type["RADIO"] = "radio";
    Type["TELEVISION"] = "television";
    return Type;
  }({});
  _CoverageEntry.Type = Type;
  let Provider = /*#__PURE__*/function (Provider) {
    Provider["AMMCO"] = "ammco";
    Provider["AUXIPRESS"] = "auxipress";
    Provider["BELGA"] = "belga";
    Provider["FEED"] = "feed";
    Provider["KANTAR"] = "kantar";
    Provider["KNEWIN"] = "knewin";
    Provider["MEDIAWEB"] = "mediaweb";
    Provider["MELTWATER"] = "meltwater";
    Provider["MANUAL"] = "manual";
    return Provider;
  }({});
  _CoverageEntry.Provider = Provider;
})(CoverageEntry || (exports.CoverageEntry = CoverageEntry = {}));